<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useClosable } from '/app/composables/closable'
import SharingPanel from './Panel.vue'
import { isEmpty } from 'lodash'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
    },
    item: {
        type: Object,
        default: () => ({})
    },
    active: {
        type: Boolean,
        default: false
    },
    hideOverlay: {
        type: Boolean,
        default: false
    },
    query: {
        type: Object,
        default: () => ({})
    },
})

const emit = defineEmits(['open', 'close', 'update:modelValue'])

const { isOpen, payload, open, close } = useClosable(props.modelValue)
const route = useRoute()
const panel = ref(null)

isOpen.value = props.active

watch(() => props.modelValue, (val) => {
    isOpen.value = val
})
watch(isOpen, (val) => {
    emit(val ? 'open' : 'close')
    emit('update:modelValue', val)
})
watch(route, () => {
    isOpen.value = false
})

const target = computed(() => !isEmpty(payload.value) ? payload.value : props.item)

defineExpose({ open, close, isOpen })
</script>

<template>
    <div v-if="isOpen" class="modal is-open" @click.self="close">
        <div :class="{ 'modal__background': !hideOverlay }" @click="close"></div>
        <div class="modal__content">
            <SharingPanel ref="panel" :item="target" :query="query" @done="close">
                <template #actions>
                    <button aria-label="button" type="button" class="sharing-popup-panel__close-btn" @click.prevent="close">
                        <span aria-hidden="true" class="icon icon-times-circle-regular"></span>
                    </button>
                </template>
            </SharingPanel>
        </div>
    </div>
</template>
